import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'
import { Img2d10 } from '@gympass/yoga-illustrations'

import Appbar from '@components/Appbar'
import Footer from '@components/Footer'
import Container from '@components/Container'

import useInternationalization from '@hooks/useInternationalization'
import useContact from '@hooks/useContact'
import useFunnelStage from '@hooks/useFunnelStage'
import calculatePrice from '@client/services/proposal'
import * as Style from './MediumCompanies.style'

export default function MediumCompanies() {
  const { contact } = useContact()
  const { country, countryFullName, language } = useInternationalization()
  const { setFunnelStage } = useFunnelStage(countryFullName)

  useEffect(() => {
    async function getOffer() {
      const { data } = await calculatePrice(contact.employeesNumber, country)

      const offer = {
        proposalValueWithoutDiscount: data.value,
        id: contact.id,
        funnelStage: 'meeting_intent',
        commercialOfferLink: `${window.location.protocol}//${window.location.host}/digital/br/simulate/commercial-offer?magic-link=${contact.magicLink}`,
      }

      await setFunnelStage(offer)
    }
    getOffer()
  }, [])

  function backToHome() {
    window.open('https://gympass.com/digital')
  }

  function buildLinksSection(linkSection) {
    return (
      <Style.Subtitle>
        <p>
          {`${linkSection.title} `}
          <Style.Link href={linkSection.teaser.link} target="_blank">
            {linkSection.teaser.text}
          </Style.Link>{' '}
          {`${linkSection.linkSeparator} `}
          <Style.Link href={linkSection.blog.link} target="_blank">
            {linkSection.blog.text}
          </Style.Link>
        </p>
      </Style.Subtitle>
    )
  }

  function getPTLinksSection() {
    const linkSection = {
      teaser: {
        link: 'https://hs.gympass.com/hubfs/SMB/One-Pager%20Gympass.pdf',
        text: 'baixar nossa apresentação',
      },
      blog: {
        link: 'https://blog.gympass.com/',
        text: 'visitar nosso blog.',
      },
      title: 'Enquanto isso, você pode',
      linkSeparator: 'ou',
    }
    return buildLinksSection(linkSection)
  }

  function getENLinksSection() {
    const linkSection = {
      teaser: {
        link:
          'https://hs.gympass.com/hubfs/SMB/BRA-SMBs%20Project/Onepage_Gympass_SMB_US_BR.pdf',
        text: 'download our teaser',
      },
      blog: {
        link: 'https://blog.gympass.com/',
        text: 'visit our blog.',
      },
      title: 'In the meantime, you can',
      linkSeparator: 'or',
    }
    return buildLinksSection(linkSection)
  }

  function getLinksSection() {
    switch (language) {
      case 'en':
        return getENLinksSection()
      case 'pt':
      default:
        return getPTLinksSection()
    }
  }

  return (
    <section>
      <Appbar />

      <Container>
        <Style.Main>
          <Row>
            <Col md={7} xxs={12} xl-start={1} xl={8}>
              <Style.Title>
                <FormattedMessage id="smb_acquisition_thankyou.medium_companies.title" />
              </Style.Title>

              <Style.Subtitle>
                <FormattedMessage id="smb_acquisition_thankyou.medium_companies.subtitle" />
              </Style.Subtitle>

              {getLinksSection()}

              <Style.ButtonWrapper>
                <Style.Button onClick={backToHome}>
                  <Style.ButtonText>
                    <FormattedMessage id="smb_acquisition_thankyou.above_threshold.call_to_action.default" />
                  </Style.ButtonText>
                </Style.Button>
              </Style.ButtonWrapper>
            </Col>

            <Col md={5} xl={2} hide={['xxs', 'xs', 'sm']}>
              <Img2d10
                width={230}
                height={230}
                role="figure"
                aria-label="i2s-settings-modal"
              />
            </Col>
          </Row>
        </Style.Main>
      </Container>

      <Footer />
    </section>
  )
}
